import { Injectable } from '@angular/core';
import { IComponentFieldData } from '../../shared/shared.definitions';

@Injectable({
  providedIn: 'root',
})
export class GinopService {
  getFieldValue(fields: Array<IComponentFieldData>, key: string): string {
    const obj = fields.find((field) => field.key === key);
    return obj && obj.value;
  }
}
